import React, { useContext } from 'react';
import './Navbar.css'
import { useLocation, useNavigate } from 'react-router-dom';
import AppContext from '../AppContext';


const Navbar = () => {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const appContext = useContext(AppContext);


    return (
        <React.Fragment>
            <nav className='main-navbar'>
                <div>
                    {
                        (pathname.includes('/archive'))&&
                            <span className="return-sign" onClick={() => navigate(-1)}>
                                <i className="fa fa-arrow-right"></i>
                            </span>
                    }
                </div>

                <div style={{ marginLeft: 'auto', marginRight: 'auto', display: 'flex' }}>
                    <span className="text-golden">«</span>
                    <span className="mx-1" style={{ fontSize: '1.1rem' }}>{appContext.locationName}</span>
                    <span className="text-golden">»</span>
                </div>

            </nav>

        </React.Fragment>
    );
}

export default Navbar;